export default "/images/info.svg?08e859e5258a5d1b3fd898314b7f28c1";